export default __webpack_public_path__ + "static/media/customer-service.b27d2a54.svg";